import React from 'react';
import { Link } from 'react-router-dom';

interface ServiceSectionProps {
    className?: string;
}

function ServiceSection( { className = '' }: ServiceSectionProps) {
    return (
        <section className={`service-section ${className}`}>
            <div className="content-area clearfix">
                <div className="left-col">
                    <div className="inner-content">
                        <blockquote>“ It showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards”</blockquote>
                        <h4>Jhon Dow</h4>
                        <span>CEO of the company</span>
                    </div>
                </div>
                <div className="right-col">
                    <div className="section-title-s2">
                        <div className="icon">
                            <i className="fi flaticon-balance"></i>
                        </div>
                        <span>What we are expert at</span>
                        <h2>Legal Practice Areas</h2>
                        <p>Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc</p>
                    </div>
                    <div className="service-grids clearfix">
                        <div className="grid">
                            <i className="fi flaticon-parents"></i>
                            <h3><Link to="/family-law">Family Law</Link></h3>
                            <p>Samsa was a travelling salesman and above it there</p>
                        </div>
                        <div className="grid">
                            <i className="fi flaticon-wounded"></i>
                            <h3><Link to="/personal-injury">Personal Injury</Link></h3>
                            <p>Samsa was a travelling salesman and above it there</p>
                        </div>
                        <div className="grid">
                            <i className="fi flaticon-thief"></i>
                            <h3><Link to="/criminal-law">Criminal Law</Link></h3>
                            <p>Samsa was a travelling salesman and above it there</p>
                        </div>
                        <div className="grid">
                            <i className="fi flaticon-mortarboard"></i>
                            <h3><Link to="/education-law">Education Law</Link></h3>
                            <p>Samsa was a travelling salesman and above it there</p>
                        </div>
                        <div className="grid">
                            <i className="fi flaticon-architecture-and-city"></i>
                            <h3><Link to="/real-estate-law">Real Estate Law</Link></h3>
                            <p>Samsa was a travelling salesman and above it there</p>
                        </div>
                        <div className="grid">
                            <i className="fi flaticon-save-money"></i>
                            <h3><Link to="/business-law">Business Law</Link></h3>
                            <p>Samsa was a travelling salesman and above it there</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ServiceSection;